


























import { Constants } from '@/constants';
import { PartyModel, WorkTaskEvaluationGroupModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { partiesStore } from '@/libs/parties/+state/store';
import { workTaskEvaluationsGroupsStore } from '@/libs/work-task-evaluation-groups/+state/store';
import Page from '@/Page.vue';
import moment from 'moment';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';

@Component({})
export default class DashboardClientEvaluationColumn extends Page {

    @Prop() tenantId!: string;

    get items (): PartyModel[] {
        return partiesStore.useGetter(CrudGetter.Data, "ClientsToEvaluate") as PartyModel[];
    }

    mounted () {
        this.load();
    }

    load () {
        partiesStore.dispatch(CrudAction.GetAll, createCrudQueryPayload<PartyModel>([
			{ field: "nextWorkTaskEvaluationDate", index: 1, order: "asc" },
			{ field: "firstName", index: 2, order: "asc" },
			{ field: "lastName", index: 3, order: "asc" }
		], [
            { field: "nextWorkTaskEvaluationDate", op: "lte", comparand: moment().format("YYYY-MM-DDT23:59:59") },
            { field: "clientStateId", op: "eq", comparand: Constants.PartyStateActiveId }
        ], { pageIndex: 1, pageSize: 50 }, false, "ClientsToEvaluate"))
    }

}
